export function genOptionLoader(fetcher, mapper) {
  return (inputValue, callback) => {
    fetcher(`keyword=${inputValue}`).then(({ data: { data } }) => {
      const { items = [] } = data ?? {};

      const options = items.map(mapper);

      callback(options);
    });
  };
}

export const genOptionLoaderParams = (
  fetcher,
  mapper,
  currentTimeout,
  setCurrentTimeout
) => {
  return (inputValue, callback) => {
    clearTimeout(currentTimeout);
    setCurrentTimeout(
      setTimeout(() => {
        fetcher(inputValue).then(({ data: { data } }) => {
          const options = data.items.map(mapper);
          callback(options);
        });
      }, 500)
    );
  };
};

export function genOptionLoaderDebounced(fetcher, mapper) {
  let timeout = null;

  return (inputValue, callback) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      fetcher(inputValue).then(({ data: { data: { items = [] } = {} } }) => {
        const options = items.map(mapper);
        callback(options);
      });
    }, 500);
  };
}
